// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__3gG-j","author":"Table_author__1COi5","authorImage":"Table_authorImage__gpl7p","unreadRow":"Table_unreadRow__p4A_k"};